import { FETCH_QUESTION_PROMPTER_FAILURE, FETCH_QUESTION_PROMPTER_REQUEST, FETCH_QUESTION_PROMPTER_SUCCESS } from "../actions/questionsPrompterDataActions";

  const initialState = {
    acc_bu_questions: [],
    acc_bu_questions_loading: true,
    acc_bu_questions_error: null,
  };
  
  const questionsPrompterDataReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_QUESTION_PROMPTER_REQUEST:
        return { ...state, acc_bu_questions_loading: true , payload: action.payload};
      case FETCH_QUESTION_PROMPTER_SUCCESS:
        return { ...state, acc_bu_questions_loading: false, acc_bu_questions: action.payload };
      case FETCH_QUESTION_PROMPTER_FAILURE:
        return { ...state, acc_bu_questions_loading: false, acc_bu_questions :[] , acc_bu_questions_error: action.payload };
      default:
        return state;
    }
  };
  
  export default questionsPrompterDataReducer;
  